<div class="modal">

	<div class="header">
		<div class="return" (click)="back()"><img src="/assets/images/icons/Plus.svg" alt="img">
		</div>
		<div class="title">Ingreso Automático</div>
	</div>

	<div class="body">
		<mat-form-field appearance="outline">
			<mat-label>Cantidad</mat-label>
			<input matInput type="text" [(ngModel)]="autoingreso.cantidad">
			<span matSuffix class="euro-suffix">€</span>
		</mat-form-field>
	</div>

	<div mat-dialog-actions class="footer">
		<button mat-button class="cancel" (click)="back()">Cancelar</button>
		<button mat-button class="submit" (click)="onSubmit()">Actualizar</button>
	</div>
</div>